<template>
  <div id="app">
    <router-view />

    <div v-if="needInitialize">
      <websocket></websocket>
      <init-bell></init-bell>
      <init-support></init-support>
      <init-balance v-if="checkPermission('user')"></init-balance>
      <app-leave></app-leave>
    </div>
  </div>
</template>

<script>

import Websocket from "./appComponents/Websocket.vue";
import InitBell from "./appComponents/InitBell.vue";
import InitSupport from "./appComponents/InitSupport.vue";
import InitBalance from "./appComponents/InitBalance.vue";
import AppLeave from "./appComponents/AppLeave.vue";
import permissionMixin from "@/components/mixins/Permissions";

export default {
  components: {AppLeave, InitBalance, InitSupport, InitBell, Websocket},
  mixins: [permissionMixin],
  data() {
    return {
      breakRoutes: [
          'Home', 'Login', 'Register', 'Forget', 'Thankyou', 'Confirm',
          'ForgetAction', 'ServiceWork', 'NotFound', null
      ]
    }
  },
  computed: {
    needInitialize() {
      return !this.breakRoutes.includes(this.$route.name);
    }
  },
}
</script>

<style lang="less" src="./style/main.less"></style>
